/**
 * Format utilities - re-exports from existing utility modules
 * This file provides backward compatibility for existing imports
 */

// Import utilities first
import { numberUtil } from './numberUtil';
import { dateUtil } from './dateUtil';

// Re-export namespaces
export { numberUtil };
export { dateUtil };

// Re-export individual functions for backward compatibility
export const formatCurrency = numberUtil.formatCurrency;
export const formatDate = dateUtil.formatDate;
export const DateFormat = dateUtil.DateFormat;
export const formatDateTime = dateUtil.formatDateTime;
